
import { Vue } from "vue-class-component";

export default class Bars extends Vue {}
